import { render, staticRenderFns } from "./DiscountRights.vue?vue&type=template&id=6828ea6e&"
import script from "./DiscountRights.vue?vue&type=script&lang=js&"
export * from "./DiscountRights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports